module.exports = __webpack_public_path__ + "static/media/Icon Email.4fa4cf4e.svg";